
import React, {useState, useEffect, useContext,useRef} from "react";
import {useHistory} from "react-router-dom";
import classNames from "classnames";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";

import {
    Grid,
    FormGroup,
    FormControl,
    ControlLabel,
    Tooltip,
    OverlayTrigger
} from "react-bootstrap";

import ReactTable from "components/ReactTable/ReactTable.js";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";
import rest from "../../API/api";
import { QuestionsContext } from "../../context/QuestionsContext";
import { UserLoginContext } from "../../context/UserLoginContext";
import { authenticatedFetch } from "../../services/authService";

const QuestionsTable = () => {
    const [questionsState, setQuestionsState] = useContext(QuestionsContext);
    const [userState, setUserState] = useContext(UserLoginContext);
    const [alert, setalert] = React.useState(null);
    const notificationAlertRef = useRef(null);
    const history = useHistory();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [data, setData] = React.useState([]);


    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    function useForceUpdate() {
        const [, setToggle] = useState(false);
        return () => setToggle(toggle => !toggle);
    }

    // Update table data whenever questions change
    useEffect(() => {
        if (userState.status && questionsState.theQuestions) {
            const tableData = questionsState.theQuestions.map((theQuestion, i) => {
                return {
                    id: theQuestion._id,
                    Title: theQuestion.Title,
                    Question: theQuestion.Question,

                    actions: (
                        <div className="actions-right">
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"add_" + i}>Add New Question</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        let tURL = "/admin/addquestion";
                                        await history.push(tURL);
                                    }}
                                    color="info"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-add"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"edit_" + i}>Edit Question</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        setQuestionsState((prevquestionsState) => ({
                                            ...prevquestionsState,
                                            theQuestion: theQuestion}));
                                        let tURL = "/admin/editquestion/";
                                        await history.push(tURL);
                                    }}
                                    color="warning"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-pencil"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"delete_" + i}>Delete Question</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        var theQuestions = [...questionsState.theQuestions];
                                        theQuestions.find((o, idx) => {
                                            if (o._id === theQuestion._id) {
                                                _deleteQuestionAlert(o._id, theQuestions, idx);
                                                return true;
                                            }
                                            return false;
                                        });
                                    }}
                                    color="danger"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-remove"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                        </div>
                    )
                };
            });
            setData(tableData);
        }
    }, [questionsState.theQuestions, userState.status]);

    useEffect(() => {
        const getQuestions = async () => {
            const questionsList = await authenticatedFetch(rest.questions, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            });
            const questionsData = await questionsList.json();
            setQuestionsState((prevquestionsState) => ({
                ...prevquestionsState,
                theQuestions: questionsData
            }));
        };
        getQuestions();
    }, [dataLoaded]);

    const fetchQuestions = async () => {
        const questionsList = await authenticatedFetch(rest.questions, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        });
        const questionsResponse = await questionsList;
        const questionsData = await questionsResponse.json();
        return(questionsData);
    };

    const _edit_question = async (id) => {
        //Grab the current record from MongoDB
    };

    const _delete_question = async (id) => {
        let tempURL = rest.questions + '/' + id;
        const questionsList = await authenticatedFetch(tempURL, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        });
        const questionsResponse = await questionsList;
        const questionsData = await questionsResponse.json();
    };

    const _deleteQuestionAlert = async (id,questions,index) => {
        setalert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes, delete it!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure?"
                style={{display: "block"}}
                onConfirm={async () => {
                    questions.splice(index, 1);
                    setQuestionsState((prevquestionsState) => ({
                        ...prevquestionsState,
                        theQuestions: questions
                    }));
                    await _delete_question(id);
                    setalert(null);
                    notify("success", "Question has been deleted successfully!");
                    setDataLoaded(!dataLoaded);
                }}
                onCancel={() =>  {
                    setalert(null);
                }}
            >
                Are you sure you want to delete this question?
            </SweetAlert>
        );
    };
    if (userState.status) {
        return (
            <>
                <div className="rna-container">
                    <NotificationAlert ref={notificationAlertRef} />
                </div>
                <div className="content">
                    <Col md={8} className="ml-auto mr-auto">
                        <h2 className="text-center">Our Questions</h2>
                        <p className="text-center">
                            This is a list of the custom questions we may attach to our event registrations
                        </p>
                    </Col>
                    <Row className="mt-5">
                        <Col xs={12} md={12}>
                            <Card>
                                <CardHeader>
                                    <Row>
                                        <Col md="6">
                                            <CardTitle tag="h4">Our Questions</CardTitle>
                                        </Col>
                                        <Col md="6" className="text-right">
                                            <Button
                                                color="info"
                                                onClick={() => history.push("/admin/addquestion")}
                                                className="animation-on-hover"
                                            >
                                                <i className="tim-icons icon-simple-add"/> Add Question
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        data={data}
                                        filterable
                                        columns={[
                                            {
                                                Header: "Title",
                                                accessor: "Title"
                                            },
                                            {
                                                Header: "Question",
                                                accessor: "Question"
                                            },
                                            {
                                                Header: "Actions",
                                                accessor: "actions",
                                                sortable: false,
                                                filterable: false
                                            }
                                        ]}
                                        defaultPageSize={5}
                                        showPaginationTop
                                        showPaginationBottom={false}
                                        className="-striped -highlight"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {alert}
                </div>
            </>

        );
    }

    else {
        //alert("You must be logged in and have an active subscription to access this page!");
        history.push("/admin/dashboard");
        return(null);
    }
};

export default QuestionsTable;
